export class ReferenceModel
{
	id: number = undefined;
	name:string = undefined;
	detail: string = undefined;
	file: string = undefined;


	constructor(values) {
		this.exchange(values, false);
	}
	
	exchange(values: Object = {}, isObject=false) {
	    for (let p in values) {
	    	
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    		if(isObject) this[p].exchange(values[p]);
		    		else this[p] = values[p];
		    	} 
		    }
		}
	}
}